"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var notification_exports = {};
__export(notification_exports, {
  NotificationEventType: () => NotificationEventType
});
module.exports = __toCommonJS(notification_exports);
var NotificationEventType = /* @__PURE__ */ ((NotificationEventType2) => {
  NotificationEventType2["AddCollaborators"] = "addCollaborators";
  NotificationEventType2["RemoveCollaborators"] = "removeCollaborators";
  NotificationEventType2["CreateNotification"] = "createNotification";
  NotificationEventType2["RemoveNotifications"] = "removeNotifications";
  NotificationEventType2["UpdateNotification"] = "updateNotification";
  NotificationEventType2["CreateNotificationContext"] = "createNotificationContext";
  NotificationEventType2["RemoveNotificationContext"] = "removeNotificationContext";
  NotificationEventType2["UpdateNotificationContext"] = "updateNotificationContext";
  return NotificationEventType2;
})(NotificationEventType || {});
//# sourceMappingURL=notification.js.map
